module.exports = __webpack_public_path__ + "static/media/WSJ_Logo.svg.926a77f3.png";